/*
  SylverCar — navigation mobile par panneaux.

  Ce que fait ce fichier, et ce qu'il ne fait pas.

  Il ne decide JAMAIS de la visibilite selon la largeur d'ecran : c'est la
  feuille de style qui s'en charge, entierement sous 1024 px. Le script se
  contente de basculer des classes. Au-dessus de 1024 px le balisage mobile
  est en `display: none` des le premier octet de CSS, donc aucun clignotement
  et aucun risque pour le mega menu desktop.

  Deux deplacements de noeuds ont lieu une fois, a l'initialisation :

  1. Le bloc de navigation est remonte a la fin de `<body>`.

     Il est emis par la section du header, qui passe en `position: fixed` avec
     un `z-index: 9999` quand elle se colle. Un enfant ne peut pas sortir du
     contexte d'empilement de son parent : le menu se serait retrouve coince
     sous les autres tiroirs du theme.

  2. Le contenu de chaque sous-panneau rejoint sa coquille.

     Liquid ne permet pas a une section de lire les blocs d'une autre. Les six
     intitules vivent dans `header-inline`, le contenu des panneaux dans
     `mega-menu`. Chaque moitie est donc rendue par la section qui la possede —
     aucune duplication de la source de verite — et raccordee ici. Les deux
     moities sont du HTML servi par le serveur : rien n'est fabrique en JS.

     La seconde moitie voyage avec la charge utile du tiroir mobile, que le
     theme telecharge de son cote au chargement de la page. Elle peut donc
     arriver apres nous : on la prend si elle est deja la, sinon on guette son
     insertion. Le premier ecran, lui, est present des le depart — le menu est
     ouvrable immediatement.
*/
(function () {
  'use strict';

  var LARGEUR_MAXI = 1024;
  var racine, calques, hamburger, ancienFocus, positionPage = 0;
  var pile = [];          // panneaux ouverts, du plus ancien au plus recent
  var scrolls = {};       // position de defilement memorisee par panneau

  /* ---------------------------------------------------------------------
     Assemblage
     --------------------------------------------------------------------- */
  // Deplace vers leur coquille tous les fragments presents. Renvoie true
  // quand il n'en reste plus aucun a placer.
  function raccorder() {
    var sources = document.querySelectorAll('[data-sc-mnav-contenu]');
    for (var i = 0; i < sources.length; i++) {
      var source = sources[i];
      var cible = racine.querySelector(
        '[data-sc-panneau="' + source.getAttribute('data-sc-mnav-contenu') + '"] [data-sc-corps]'
      );
      if (!cible) continue;
      while (source.firstChild) cible.appendChild(source.firstChild);
      if (source.parentNode) source.parentNode.removeChild(source);
    }
    return sources.length > 0;
  }

  function assembler() {
    racine = document.querySelector('[data-sc-mnav]');
    if (!racine) return false;

    if (racine.parentNode !== document.body) document.body.appendChild(racine);

    if (!raccorder()) {
      // Le tiroir du theme n'a pas encore recu sa charge utile. On guette son
      // insertion plutot que de relancer une requete : ce serait la meme,
      // payee deux fois. L'observateur se debranche des qu'il a servi.
      var tiroir = document.getElementById('t4s-menu-drawer') || document.body;
      var guetteur = new MutationObserver(function () {
        if (raccorder()) guetteur.disconnect();
      });
      guetteur.observe(tiroir, { childList: true, subtree: true });
    }

    calques = racine.querySelectorAll('[data-sc-panneau]');
    return true;
  }

  /* ---------------------------------------------------------------------
     Verrou du defilement

     La page est figee en `fixed` et remontee de sa propre position : c'est la
     seule methode qui tienne sur iOS, ou `overflow: hidden` sur le body est
     ignore. La position est restituee telle quelle a la fermeture.
     --------------------------------------------------------------------- */
  function verrouiller() {
    positionPage = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.style.top = -positionPage + 'px';
    document.documentElement.classList.add('sc-mnav-verrou');
    document.body.classList.add('sc-mnav-verrou');
  }

  function deverrouiller() {
    document.documentElement.classList.remove('sc-mnav-verrou');
    document.body.classList.remove('sc-mnav-verrou');
    document.body.style.top = '';

    // Tant que le body est fige, il est hors du flux et le document ne mesure
    // plus que la hauteur de l'ecran — 812 px au lieu de 10 751 sur l'accueil.
    // Un scrollTo lance dans la foulee serait rabattu a zero, et la page
    // reviendrait en haut a chaque fermeture.
    //
    // Lire scrollHeight sur l'element defilant force le navigateur a refaire
    // sa mise en page immediatement : la hauteur reelle est retrouvee avant
    // qu'on ne redescende. La lecture doit porter sur documentElement, pas sur
    // body — c'est lui qui defile.
    var retour = positionPage;
    void document.documentElement.scrollHeight;
    window.scrollTo(0, retour);
    // Filet, au cas ou la mise en page tarderait malgre tout.
    requestAnimationFrame(function () {
      if (Math.abs(window.pageYOffset - retour) > 2) window.scrollTo(0, retour);
    });
  }

  /* ---------------------------------------------------------------------
     Panneaux
     --------------------------------------------------------------------- */
  function panneau(nom) {
    return racine.querySelector('[data-sc-panneau="' + nom + '"]');
  }

  function memoriser(nom) {
    var p = panneau(nom);
    var corps = p && p.querySelector('[data-sc-corps]');
    if (corps) scrolls[nom] = corps.scrollTop;
  }

  function restituer(nom) {
    var p = panneau(nom);
    var corps = p && p.querySelector('[data-sc-corps]');
    if (corps) corps.scrollTop = scrolls[nom] || 0;
  }

  function afficher(nom) {
    var p = panneau(nom);
    if (!p) return;
    p.classList.add('is--visible');
    p.removeAttribute('aria-hidden');
    // Le defilement se restitue apres la trame de mise en page, sinon la
    // hauteur du contenu n'est pas encore connue et le scrollTop est ignore.
    requestAnimationFrame(function () { restituer(nom); });
  }

  function masquer(nom) {
    var p = panneau(nom);
    if (!p) return;
    memoriser(nom);
    p.classList.remove('is--visible');
    p.setAttribute('aria-hidden', 'true');
  }

  function declencheur(nom) {
    return racine.querySelector('[data-sc-ouvrir="' + nom + '"]');
  }

  /* ---------------------------------------------------------------------
     Ouverture, navigation, fermeture
     --------------------------------------------------------------------- */
  function ouvrir(evenement) {
    if (window.innerWidth > LARGEUR_MAXI) return;
    if (evenement) { evenement.preventDefault(); evenement.stopPropagation(); }

    ancienFocus = document.activeElement;
    verrouiller();
    pile = ['racine'];
    afficher('racine');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');

    // Le focus va sur le panneau, pas sur le bouton de fermeture : au doigt,
    // un bouton focalise par programme affiche un anneau gris disgracieux,
    // alors qu'un conteneur en tabindex="-1" n'en montre aucun tout en
    // amorcant correctement le parcours clavier.
    panneau('racine').focus({ preventScroll: true });
  }

  function fermer() {
    for (var i = pile.length - 1; i >= 0; i--) {
      var nom = pile[i];
      masquer(nom);
      var d = declencheur(nom);
      if (d) d.setAttribute('aria-expanded', 'false');
    }
    var r = panneau('racine');
    if (r) r.classList.remove('is--enRetrait');
    pile = [];
    deverrouiller();
    // preventScroll est indispensable ici : donner le focus a un element le
    // fait defiler dans la vue. Le hamburger etant en haut de page, la
    // fermeture ramenait le lecteur au sommet et annulait, une trame plus
    // tard, la position que le deverrouillage venait de restituer.
    if (hamburger) {
      hamburger.setAttribute('aria-expanded', 'false');
      hamburger.focus({ preventScroll: true });
    } else if (ancienFocus && ancienFocus.focus) {
      ancienFocus.focus({ preventScroll: true });
    }
  }

  function entrer(nom) {
    var precedent = pile[pile.length - 1];
    memoriser(precedent);
    if (precedent === 'racine') panneau('racine').classList.add('is--enRetrait');
    else masquer(precedent);

    pile.push(nom);
    afficher(nom);

    var d = declencheur(nom);
    if (d) d.setAttribute('aria-expanded', 'true');

    panneau(nom).focus({ preventScroll: true });
  }

  function revenir() {
    if (pile.length < 2) { fermer(); return; }
    var nom = pile.pop();
    masquer(nom);
    var d = declencheur(nom);
    if (d) d.setAttribute('aria-expanded', 'false');

    var precedent = pile[pile.length - 1];
    if (precedent === 'racine') {
      panneau('racine').classList.remove('is--enRetrait');
      restituer('racine');
    } else {
      afficher(precedent);
    }
    if (d) d.focus({ preventScroll: true });
  }

  /* ---------------------------------------------------------------------
     Clavier : Echap ferme, Tab reste enferme dans le panneau visible
     --------------------------------------------------------------------- */
  // Le panneau lui-meme est en tabindex="-1" : il recoit le focus a
  // l'ouverture mais reste hors du parcours de tabulation.
  var FOCUSABLES = 'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])';

  function auClavier(e) {
    if (!pile.length) return;

    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      fermer();
      return;
    }
    if (e.key !== 'Tab') return;

    var courant = panneau(pile[pile.length - 1]);
    if (!courant) return;
    var cibles = courant.querySelectorAll(FOCUSABLES);
    if (!cibles.length) return;

    var premier = cibles[0];
    var dernier = cibles[cibles.length - 1];

    if (e.shiftKey && document.activeElement === premier) {
      e.preventDefault();
      dernier.focus();
    } else if (!e.shiftKey && document.activeElement === dernier) {
      e.preventDefault();
      premier.focus();
    } else if (!courant.contains(document.activeElement)) {
      e.preventDefault();
      premier.focus();
    }
  }

  /* ---------------------------------------------------------------------
     Branchements
     --------------------------------------------------------------------- */
  function demarrer() {
    if (!assembler()) return;

    // Le hamburger du theme ouvre le tiroir natif de Kalles. On l'intercepte
    // en phase de capture pour le devancer, et on coupe la propagation :
    // le tiroir natif n'est jamais sollicite, donc jamais affiche.
    hamburger = document.querySelector('.t4s-push-menu-btn[data-menu-drawer]');
    if (hamburger) {
      hamburger.setAttribute('aria-controls', 'sc-mobile-nav');
      hamburger.setAttribute('aria-expanded', 'false');
      hamburger.addEventListener('click', ouvrir, true);
    }

    racine.addEventListener('click', function (e) {
      var cible = e.target.closest ? e.target.closest('[data-sc-ouvrir], [data-sc-retour], [data-sc-fermer]') : null;
      if (!cible) return;

      if (cible.hasAttribute('data-sc-fermer')) { e.preventDefault(); fermer(); return; }
      if (cible.hasAttribute('data-sc-retour')) { e.preventDefault(); revenir(); return; }
      e.preventDefault();
      entrer(cible.getAttribute('data-sc-ouvrir'));
    });

    document.addEventListener('keydown', auClavier);

    // Passage en desktop alors que le menu est ouvert : on rend la page a son
    // etat normal plutot que de laisser un verrou orphelin.
    window.addEventListener('resize', function () {
      if (pile.length && window.innerWidth > LARGEUR_MAXI) fermer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
